// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","Main":"App_Main__HQkvd","BorderBottom":"App_BorderBottom__2rtFT","MinHeight":"App_MinHeight__gaG8Y"};